export function formatPharmacyPhoneNumber(phoneNumber: string): string {
    const numberAsArray = phoneNumber.split('-');
    if (numberAsArray.length !== 3) return null;

    return `(${numberAsArray[0]}) ${numberAsArray[1]}-${numberAsArray[2]}`;
}
